<h2 mat-dialog-title>Seleziona Codice ATECO</h2>
    
    <mat-dialog-content>
      <!-- Search field -->
      <mat-form-field appearance="outline" class="w-100 mb-3 mt-2">
        <mat-label>Cerca codice ATECO</mat-label>
        <input matInput [(ngModel)]="searchTerm" (ngModelChange)="filterAtecoCodes()" placeholder="Cerca per nome o codice...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- ATECO codes list -->
      <div *ngIf="filteredAtecoCodes.length === 0" class="text-center p-3 text-muted">
        Nessun codice ATECO trovato
      </div>

      <mat-radio-group [(ngModel)]="selectedAtecoCodeId" class="ateco-radio-group">
        <div *ngFor="let code of filteredAtecoCodes" 
             class="ateco-radio-option p-2 mb-2 border rounded"
             [class.selected]="selectedAtecoCodeId === code.id">
          <mat-radio-button [value]="code.id" class="w-100">
            <div class="d-flex flex-column">
              <strong>{{ code.name }}</strong>
              <small class="text-muted">
                {{ code.ateco_division || '' }}.{{ code.ateco_class || '' }}.{{ code.ateco_subcategory || '' }}
              </small>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Annulla</button>
      <button mat-raised-button color="primary" 
              [disabled]="!selectedAtecoCodeId"
              (click)="onConfirm()">
        Seleziona
      </button>
    </mat-dialog-actions>
